module.exports = __webpack_public_path__ + "sl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sl.svg
// module id = 808
// module chunks = 0